// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg width=%2716%27 height=%2716%27 viewBox=%270 0 16 16%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M8.00045 8.78126L11.3003 5.48145L12.2431 6.42425L8.00045 10.6669L3.75781 6.42425L4.70063 5.48145L8.00045 8.78126Z%27 fill=%27%231E1F2F%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-peer-com-container {
  container-type: inline-size;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  height: 100%;
  min-width: 328px;
  display: flex;
  flex-direction: column;
}

.stock-peer-com-container > div {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
}

.stock-peer-com-container .pagination-background {
  margin-top: auto;
  cursor: auto;
}

.stock-peer-com-container .select-container {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 14px;
  display: flex;
  justify-content: flex-start;
}

.stock-peer-com-container select {
  width: 100%;
  opacity: 1;
  padding-top: 8px;
  padding-right: 16px;
  padding-bottom: 8px;
  padding-left: 16px;
  border-radius: 8px;
  border-width: 1px;
  border: 1px solid var(--color-brand);

  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    no-repeat right 0.75rem center;
  background-size: 16px 16px;

  color: var(--text-primary);
  font-size: 16px;
}

.stock-peer-com-container select:focus {
  outline: none;
}

.stock-peer-com-container .peer-com-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
  table-layout: fixed;
  margin-top: 10px;
}

.stock-peer-com-container .peer-com-table thead th svg {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 2px;
  transition: transform 0.2s ease;
}

.stock-peer-com-container .peer-com-table thead th {
  border-bottom: 1px solid var(--border-line);
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0;
  color: var(--text-subheader);
  vertical-align: sub;
  white-space: nowrap;
  height: 32px;
  padding-bottom: 0px;
  box-sizing: border-box;
}

.stock-peer-com-container .peer-com-table thead th div {
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 2px;
}

.stock-peer-com-container .peer-com-table thead th.no div,
.stock-peer-com-container .peer-com-table thead th.ticker div,
.stock-peer-com-container .peer-com-table thead th.tickerName div,
.stock-peer-com-container .peer-com-table thead th.name div,
.stock-peer-com-container .peer-com-table thead th.ctry div,
.stock-peer-com-container .peer-com-table thead th.numofbrokers div {
  justify-content: flex-start;
}

.stock-peer-com-container .peer-com-table thead th div svg {
  flex-shrink: 0;
}

.stock-peer-com-container .peer-com-table thead th .peer-com-header-label {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-word;
}

.stock-peer-com-container .peer-com-table thead th:first-child {
  width: 22px;
  border-bottom: 0px;
}

.stock-peer-com-container .peer-com-table thead .no {
  text-align: start;
  width: 20px;
}

.stock-peer-com-container .peer-com-table thead .ticker {
  text-align: start;
  width: 100px;
}

.stock-peer-com-container .peer-com-table thead .name {
  text-align: start;
  width: 20%;
}

.stock-peer-com-container .peer-com-table thead .tickerName {
  text-align: start;
}

.stock-peer-com-container .peer-com-table thead .ctry {
  width: 5%;
}

.stock-peer-com-container .peer-com-table thead .last {
  text-align: end;
  width: 14%;
}

.stock-peer-com-container .peer-com-table thead .pctchng {
  text-align: end;
  width: 12%;
}

.stock-peer-com-container .peer-com-table thead .mktcap {
  text-align: end;
  width: 140px;
}

.stock-peer-com-container
  .peer-com-table
  thead
  .mktcap
  .peer-com-header-currency {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0;
  color: var(--text-subheader);
}

.stock-peer-com-container .peer-com-table thead .peratio {
  text-align: end;
  width: 90px;
}

.stock-peer-com-container .peer-com-table thead .coscore {
  text-align: end;
  width: 144px;
}

.stock-peer-com-container .peer-com-table thead .divyield {
  text-align: end;
  width: 90px;
}

.stock-peer-com-container .peer-com-table thead .consensus {
  text-align: end;
  width: 120px;
}

.stock-peer-com-container .peer-com-table thead .perf1M {
  text-align: end;
  width: 120px;
}

.stock-peer-com-container .peer-com-table thead .perf3M {
  text-align: end;
  width: 120px;
}

.stock-peer-com-container .peer-com-table thead .perf6M {
  text-align: end;
  width: 120px;
}

.stock-peer-com-container .peer-com-table thead .perf1Y {
  text-align: end;
  width: 120px;
}

.stock-peer-com-container .peer-com-table thead .numofbrokers {
  text-align: center;
}

.stock-peer-com-container .peer-com-table thead .beta {
  text-align: end;
  width: 90px;
}

.stock-peer-com-container .peer-com-table thead .avgvol30 {
  text-align: end;
  width: 115px;
}

.stock-peer-com-container .peer-com-table thead .rsi {
  text-align: end;
  width: 90px;
}

.stock-peer-com-container .peer-com-table thead .ma5d {
  text-align: end;
  width: 90px;
}

.stock-peer-com-container .peer-com-table thead .ma25d {
  text-align: end;
  width: 90px;
}

.stock-peer-com-container .peer-com-table thead .per {
  text-align: end;
  width: 90px;
}

.stock-peer-com-container .peer-com-table thead .pbr {
  text-align: end;
  width: 90px;
}

.stock-peer-com-container .peer-com-table thead .roe {
  text-align: end;
  width: 90px;
}

.stock-peer-com-container .peer-com-table thead .overall {
  text-align: end;
  width: 80px;
}

.stock-peer-com-container .peer-com-table thead .fundamental {
  text-align: end;
  width: 125px;
}

.stock-peer-com-container .peer-com-table thead .earnings {
  text-align: end;
  width: 100px;
}

.stock-peer-com-container .peer-com-table thead .valuation {
  text-align: end;
  width: 90px;
}

.stock-peer-com-container .peer-com-table thead .performance {
  text-align: end;
  width: 115px;
}

.stock-peer-com-container .peer-com-table thead .risk {
  text-align: end;
  width: 80px;
}

.stock-peer-com-container .peer-com-table thead .targetprice {
  text-align: end;
  width: 120px;
}

.stock-peer-com-container .peer-com-table thead .brokerrating {
  text-align: end;
  width: 145px;
}

.stock-peer-com-container .peer-com-table thead th:last-child {
  width: 22px;
  border-bottom: 0px;
}

.stock-peer-com-container .peer-com-table thead .lastcolumn {
  width: 0;
}

.stock-peer-com-container .peer-com-table tbody tr {
  vertical-align: middle;

  &:nth-child(2n) {
    background-color: var(--row-dark);
  }
}

.stock-peer-com-container .peer-com-table tbody .numofbrokers {
  text-align: center;
}

.stock-peer-com-container .peer-com-table tbody td {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  vertical-align: middle;
  white-space: nowrap;
  box-sizing: border-box;

  &:first-child {
    padding-left: 32px;
  }

  &.nochange {
    color: var(--text-unchg-color);
  }

  &.positive {
    color: var(--text-up-color);
  }

  &.negative {
    color: var(--text-down-color);
  }

  &.no {
    text-align: justify;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    color: var(--text-subheader);
    padding-right: 8px;
  }

  &.ctry {
    text-align: left;
    padding-right: 8px;
    text-align: center;
  }

  &.ctry svg {
    width: 20px;
    height: 20px;
  }

  &.ticker {
    text-align: left;
    font-weight: 700;
    font-size: 16px;
    color: var(--text-ticker);
    padding-right: 8px;
    width: 6%;
    cursor: pointer;
  }

  &.ticker.link-enabled {
    cursor: pointer;
  }

  &.name {
    text-align: left;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0;
    color: #1e1f2f;
    width: 20%;
  }

  &.name.link-enabled {
    cursor: pointer;
  }

  &.name.link-enabled:hover {
    color: var(--accent-link);
  }

  &.tickerName {
    text-align: left;
    width: 30%;
    min-width: 30%;
    padding-left: 8px;
  }

  &.tickerName .ticker {
    font-weight: 400;
    font-size: 16px;
    color: var(--text-primary);
    cursor: pointer;
  }

  &.tickerName .name {
    text-align: left;
    font-weight: 400;
    font-size: 12px;
    letter-spacing: 0;
    color: var(--text-primary);
    padding-right: 8px;
  }

  &.tickerName .tickerNameSmallScreen {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  &.tickerName .tickerNameSmallScreen .name {
    width: 100%;
  }

  &.last {
    text-align: right;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0;
    padding-right: 8px;
    color: var(--text-primary);
  }

  &.pctchng {
    text-align: right;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0;
    padding-right: 8px;
  }

  &.mktcap {
    text-align: right;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0;
    color: var(--text-primary);
    padding-right: 8px;
  }

  &.mktcap .peer-com-header-currency {
    font-size: 11px;
    line-height: 100%;
  }

  &.peratio {
    text-align: right;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0;
    color: var(--text-primary);
    padding-right: 8px;
  }

  &.divyield {
    text-align: right;
    font-weight: 400;
    font-size: 16px;
    color: var(--text-primary);
    padding-right: 8px;
  }

  &.coscore {
    vertical-align: middle;
    padding-right: 8px;
  }

  &.coscore span {
    width: 44px;
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    border-radius: 1px;
    white-space: nowrap;
    text-align: center;
    padding-top: 3px;
    padding-bottom: 3px;
  }

  &.coscore .score {
    text-align: center;
    background-color: var(--surface-secondary);
    color: var(--text-primary);
  }

  &.coscore .score-10 {
    text-align: center;
    background-color: var(--surface-brand);
    color: var(--text-invert);
  }

  &.div-consensus {
    vertical-align: middle;
  }

  &.div-consensus span {
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    border-radius: 1px;
    white-space: nowrap;
    text-align: center;
    padding-top: 3px;
    padding-bottom: 3px;
  }

  &.div-consensus .strongbuy {
    color: var(--text-invert);
    background-color: var(--heatmap-up-5);
  }

  &.perf1M {
    text-align: right;
    font-weight: 400;
    font-size: 16px;
    border-left: 0px solid var(--surface-primary);
    width: 120px;
    padding-right: 8px;
    max-height: 56px;
    padding-top: 0px;
    padding-bottom: 0px;
  }

  &.perf3M {
    text-align: right;
    font-weight: 400;
    font-size: 16px;
    border-left: 0px solid var(--surface-primary);
    width: 120px;
    padding-right: 8px;
    max-height: 56px;
    padding-top: 0px;
    padding-bottom: 0px;
  }

  &.perf6M {
    text-align: right;
    font-weight: 400;
    font-size: 16px;
    border-left: 0px solid var(--surface-primary);
    width: 120px;
    padding-right: 8px;
    max-height: 56px;
    padding-top: 0px;
    padding-bottom: 0px;
  }

  &.perf1Y {
    text-align: right;
    font-weight: 400;
    font-size: 16px;
    border-left: 0px solid var(--surface-primary);
    width: 120px;
    padding-right: 8px;
    max-height: 56px;
    padding-top: 0px;
    padding-bottom: 0px;
  }

  &.numofbrokers {
    text-align: center;
  }

  &.beta {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    letter-spacing: 0px;
    text-align: right;
    padding-right: 8px;
    color: var(--text-primary);
  }

  &.avgvol30 {
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0px;
    text-align: right;
    padding-right: 8px;
    color: var(--text-primary);
  }

  &.rsi {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    letter-spacing: 0px;
    text-align: right;
    padding-right: 8px;
    color: var(--text-primary);
  }

  &.ma5d {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    letter-spacing: 0px;
    text-align: right;
    padding-right: 8px;
  }

  &.ma25d {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    letter-spacing: 0px;
    text-align: right;
    padding-right: 8px;
  }

  &.per {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    letter-spacing: 0px;
    text-align: right;
    padding-right: 8px;
    color: var(--text-primary);
  }

  &.pbr {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    letter-spacing: 0px;
    text-align: right;
    padding-right: 8px;
    color: var(--text-primary);
  }

  &.roe {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    letter-spacing: 0px;
    text-align: right;
    padding-right: 8px;
    color: var(--text-primary);
  }

  &.overall {
    padding-right: 8px;
    text-align: center;
  }

  &.overall span {
    width: 44px;
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    border-radius: 1px;
    white-space: nowrap;
    padding-top: 3px;
    padding-bottom: 3px;
  }

  &.overall .score {
    background-color: var(--surface-secondary);
    color: var(--text-primary);
    text-align: center;
  }

  &.overall .score-10 {
    background-color: var(--surface-brand);
    color: var(--text-invert);
    text-align: center;
  }

  &.fundamental {
    padding-right: 8px;
    text-align: center;
  }

  &.fundamental span {
    width: 44px;
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    border-radius: 1px;
    white-space: nowrap;
    padding-top: 3px;
    padding-bottom: 3px;
  }

  &.fundamental .score {
    background-color: var(--surface-secondary);
    color: var(--text-primary);
    text-align: center;
  }

  &.fundamental .score-10 {
    background-color: var(--surface-brand);
    color: var(--text-invert);
    text-align: center;
  }

  &.earnings {
    padding-right: 8px;
    text-align: center;
  }

  &.earnings span {
    width: 44px;
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    border-radius: 1px;
    white-space: nowrap;
    padding-top: 3px;
    padding-bottom: 3px;
  }

  &.earnings .score {
    background-color: var(--surface-secondary);
    color: var(--text-primary);
    text-align: center;
  }

  &.earnings .score-10 {
    background-color: var(--surface-brand);
    color: var(--text-invert);
    text-align: center;
  }

  &.valuation {
    padding-right: 8px;
    text-align: center;
  }

  &.valuation span {
    width: 44px;
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    border-radius: 1px;
    white-space: nowrap;
    padding-top: 3px;
    padding-bottom: 3px;
  }

  &.valuation .score {
    background-color: var(--surface-secondary);
    color: var(--text-primary);
    text-align: center;
  }

  &.valuation .score-10 {
    background-color: var(--surface-brand);
    color: var(--text-invert);
    text-align: center;
  }

  &.performance {
    padding-right: 8px;
    text-align: center;
  }

  &.performance span {
    width: 44px;
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    border-radius: 1px;
    white-space: nowrap;
    padding-top: 3px;
    padding-bottom: 3px;
  }

  &.performance .score {
    background-color: var(--surface-secondary);
    color: var(--text-primary);
    text-align: center;
  }

  &.performance .score-10 {
    background-color: var(--surface-brand);
    color: var(--text-invert);
    text-align: center;
  }

  &.risk {
    padding-right: 8px;
    text-align: center;
  }

  &.risk span {
    width: 44px;
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    border-radius: 1px;
    white-space: nowrap;
    padding-top: 3px;
    padding-bottom: 3px;
  }

  &.risk .score {
    background-color: var(--surface-secondary);
    color: var(--text-primary);
    text-align: center;
  }

  &.risk .score-10 {
    background-color: var(--surface-brand);
    color: var(--text-invert);
    text-align: center;
  }

  &.targetprice {
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0px;
    text-align: right;
    padding-right: 8px;
    color: var(--text-primary);
  }

  &.brokerrating {
    vertical-align: middle;
    padding-right: 8px;
    justify-content: flex-end;
  }

  &.brokerrating span {
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0;
    border-radius: 1px;
    white-space: nowrap;
    text-align: center;
    padding-top: 3px;
    padding-bottom: 3px;
  }

  &.brokerrating .score {
    background-color: var(--surface-secondary);
    color: var(--text-primary);
    text-align: center;
  }

  &.brokerrating .score-10 {
    background-color: var(--surface-brand);
    color: var(--text-invert);
    text-align: center;
  }

  &.firstcolumn {
    width: 0;
  }

  &.lastcolumn {
    width: 0;
  }

  &:nth-last-child(2) {
    padding-right: 0px;
  }
}

.stock-peer-com-container {
  .sortbtn {
    vertical-align: middle;
  }

  .rec-strong-buy {
    background-color: var(--heatmap-up-5);
    color: var(--text-invert);
    padding: 3px 8px 3px 8px;
  }

  .rec-buy {
    background-color: var(--heatmap-up-4);
    color: var(--text-invert);
    text-align: center;
    padding: 3px 8px 3px 8px;
  }

  .rec-hold {
    background-color: var(--surface-secondary);
    color: var(--text-primary);
    text-align: center;
    padding: 3px 8px 3px 8px;
  }

  .rec-reduce {
    background-color: var(--heatmap-down-4);
    color: var(--text-invert);
    text-align: center;
    padding: 3px 8px 3px 8px;
  }

  .rec-sell {
    background-color: var(--heatmap-down-6);
    color: var(--text-invert);
    text-align: center;
    padding: 3px 8px 3px 8px;
  }

  .peer-com-whitespace {
    height: 24px;
  }

  .peer-com-pagination {
    padding: 32px;
    background-color: var(--surface-secondary);
    margin-top: auto;
  }

  .alignRight {
    display: flex;
    justify-content: flex-end;
  }

  .alignCenter {
    display: flex;
    justify-content: center;
  }

  .per-whiteBorder {
    border-top: 1px solid var(--surface-primary);
    border-bottom: 1px solid var(--surface-primary);
  }

  .peer-com-tbl-cel-flex-container {
    display: grid;
    align-items: center;
    max-width: 90%;
  }

  .peer-com-tbl-cel-text {
    flex: 1 1 0;
    min-width: 0;
    /* critical for ellipsis in flex items */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.peer-com-table-spacer {
  height: 16px;
}

.stock-peer-com-container .select-container {
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
}
.peer-com-table-spacer {
  max-height: 8px;
}
.stock-peer-com-container select {
  font-size: 13px;
  padding: 6px 10px;
}
.stock-peer-com-container .peer-com-table thead th {
  font-size: 16px;
  height: 26px;
  width: 20px;
}
.stock-peer-com-container .peer-com-table thead th:first-child,
.stock-peer-com-container .peer-com-table thead th:last-child {
  width: 8px;
}
.stock-peer-com-container .peer-com-table thead .no {
  width: 37px;
}
.stock-peer-com-container .peer-com-table thead .tickerName--ticker {
  width: 72px;
}
/* Auto width: this column absorbs the table's leftover space (table-layout
     is fixed), which keeps the fixed-width columns — notably the 139px last
     column — at exactly their declared width instead of being inflated. */
.stock-peer-com-container .peer-com-table thead .tickerName--name {
  width: auto;
}
.stock-peer-com-container .peer-com-table tbody tr {
  height: 56px;
}
.stock-peer-com-container .peer-com-table tbody td {
  font-size: 12px;
  padding-top: 12px;
  padding-bottom: 8px;
  padding-right: 4px;
}
.stock-peer-com-container .peer-com-table tbody td:first-child {
  padding-left: 8px;
}
.stock-peer-com-container .peer-com-table tbody td.no {
  font-size: 14px;
  padding-right: 4px;
  padding-top: 12px;
  padding-left: 8px;
  vertical-align: top;
}
.stock-peer-com-container .peer-com-table tbody td.name {
  font-size: 16px;
}
.stock-peer-com-container .peer-com-table tbody td.ticker {
  font-size: 12px;
  padding-right: 4px;
}
.stock-peer-com-container .peer-com-table tbody td.tickerName {
  padding-left: 36px;
}
.stock-peer-com-container .peer-com-table tbody td.tickerName .ticker {
  font-size: 16px;
  color: var(--text-ticker);
  font-weight: 700;
}
.stock-peer-com-container .peer-com-table tbody td.tickerName .name {
  font-size: 14px;
  padding-right: 4px;
}
.stock-peer-com-container .peer-com-table tbody td.ctry {
  padding-left: 24px;
  padding-top: 0px;
  padding-right: 16px;
  vertical-align: middle;
}
.stock-peer-com-container .peer-com-table tbody td.last,
.stock-peer-com-container .peer-com-table tbody td.pctchng,
.stock-peer-com-container .peer-com-table tbody td.mktcap,
.stock-peer-com-container .peer-com-table tbody td.peratio,
.stock-peer-com-container .peer-com-table tbody td.divyield,
.stock-peer-com-container .peer-com-table tbody td.targetprice,
.stock-peer-com-container .peer-com-table tbody td.beta,
.stock-peer-com-container .peer-com-table tbody td.avgvol30,
.stock-peer-com-container .peer-com-table tbody td.rsi,
.stock-peer-com-container .peer-com-table tbody td.ma5d,
.stock-peer-com-container .peer-com-table tbody td.ma25d,
.stock-peer-com-container .peer-com-table tbody td.per,
.stock-peer-com-container .peer-com-table tbody td.pbr,
.stock-peer-com-container .peer-com-table tbody td.roe,
.stock-peer-com-container .peer-com-table tbody td.perf1M,
.stock-peer-com-container .peer-com-table tbody td.perf3M,
.stock-peer-com-container .peer-com-table tbody td.perf6M,
.stock-peer-com-container .peer-com-table tbody td.perf1Y {
  font-size: 16px;
  padding-right: 4px;
}
.stock-peer-com-container .peer-com-table tbody td.coscore span,
.stock-peer-com-container .peer-com-table tbody td.overall span,
.stock-peer-com-container .peer-com-table tbody td.fundamental span,
.stock-peer-com-container .peer-com-table tbody td.earnings span,
.stock-peer-com-container .peer-com-table tbody td.valuation span,
.stock-peer-com-container .peer-com-table tbody td.performance span,
.stock-peer-com-container .peer-com-table tbody td.risk span {
  font-size: 16px;
  width: 36px;
}
.stock-peer-com-container .peer-com-table tbody td.div-consensus span,
.stock-peer-com-container .peer-com-table tbody td.brokerrating span {
  font-size: 16px;
}
.stock-peer-com-container .peer-com-table tbody td:nth-last-child(2) {
  padding-right: 0px;
}

@container (max-width: 767.98px) {
  .stock-peer-com-container .peer-com-table thead th:nth-last-child(2),
  .stock-peer-com-container .peer-com-table tbody td:nth-last-child(2) {
    width: 139px;
    overflow: hidden;
  }

  .stock-peer-com-container
    .peer-com-table
    thead
    th:nth-last-child(2)
    .peer-com-header-label {
    min-width: 0;
  }
  .stock-peer-com-container .peer-com-table tbody td:nth-last-child(2),
  .stock-peer-com-container .peer-com-table tbody td:nth-last-child(2) > div {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

@container (min-width: 768px) {
  .stock-peer-com-container .select-container {
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 14px;
  }
  .stock-peer-com-container select {
    font-size: 16px;
    padding: 8px 16px;
  }
  .peer-com-table-spacer {
    max-height: unset;
    height: 8px;
  }
  .stock-peer-com-container .peer-com-table thead th {
    height: 32px;
    &.name {
      width: 35%;
      min-width: 35%;
    }
    &:nth-last-child(2) {
      text-align: right;
      padding-right: 0px;
    }
  }
  .stock-peer-com-container .peer-com-table thead th:first-child,
  .stock-peer-com-container .peer-com-table thead th:last-child {
    width: 22px;
  }
  .stock-peer-com-container .peer-com-table thead .no {
    width: 20px;
    padding-left: 0;
  }
  .stock-peer-com-container .peer-com-table thead .tickerName {
    padding-left: 8px;
  }
  .stock-peer-com-container .peer-com-table thead .numofbrokers {
    width: 180px;
  }

  .stock-peer-com-container .peer-com-table tbody tr {
    height: 40px;
  }
  .stock-peer-com-container .peer-com-table tbody td {
    font-size: 16px;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-right: 8px;

    &:first-child {
      padding-left: 24px;
    }
    &.ticker {
      font-size: 16px;
    }

    &.no {
      padding-left: 0;
      vertical-align: middle;
    }
    &.no {
      padding-left: 0;
      padding-top: 4px;
      vertical-align: middle;
    }
    &.ctry {
      padding-right: 8px;
      padding-top: 4px;
      vertical-align: middle;
    }
    &.tickerName {
      padding-left: 8px;
    }
    &.tickerName .name {
      font-size: 12px;
      padding-right: 8px;
    }
    &:nth-last-child(2) {
      padding-right: 0px;
    }
    &:last-child {
      padding-right: 22px;
    }
  }
  .stock-peer-com-container .peer-com-table tbody td.coscore span,
  .stock-peer-com-container .peer-com-table tbody td.overall span,
  .stock-peer-com-container .peer-com-table tbody td.fundamental span,
  .stock-peer-com-container .peer-com-table tbody td.earnings span,
  .stock-peer-com-container .peer-com-table tbody td.valuation span,
  .stock-peer-com-container .peer-com-table tbody td.performance span,
  .stock-peer-com-container .peer-com-table tbody td.risk span {
    width: 44px;
  }

  .stock-peer-com-container .peer-com-table thead .ticker,
  .stock-peer-com-container .peer-com-table tbody td.ticker,
  .stock-peer-com-container .peer-com-table thead .ctry,
  .stock-peer-com-container .peer-com-table tbody td.ctry {
    padding-left: 16px;
  }

  .stock-peer-com-container .custom-select-wrapper {
    max-width: 345px;
    width: 100%;
  }
}
@container (min-width: 1200px) {
  .stock-peer-com-container .peer-com-table tbody td.pctchng {
    background-color: transparent;
  }
  .stock-peer-com-container .peer-com-table tbody td.pctchng.positive {
    color: var(--text-up-color);
  }
  .stock-peer-com-container .peer-com-table tbody td.pctchng.negative,
  .stock-peer-com-container .peer-com-table tbody td.pctchng.negative-small {
    color: var(--text-down-color);
  }
  .stock-peer-com-container .peer-com-table tbody td.pctchng.nochange {
    color: var(--text-unchg-color);
  }
  .stock-peer-com-container.tab-technical
    .peer-com-table
    tbody
    td.ma5d.positive,
  .stock-peer-com-container.tab-technical
    .peer-com-table
    tbody
    td.ma25d.positive {
    color: var(--text-up-color);
  }
  .stock-peer-com-container.tab-technical
    .peer-com-table
    tbody
    td.ma5d.negative,
  .stock-peer-com-container.tab-technical
    .peer-com-table
    tbody
    td.ma25d.negative {
    color: var(--text-down-color);
  }
  .stock-peer-com-container.tab-technical
    .peer-com-table
    tbody
    td.ma5d.nochange,
  .stock-peer-com-container.tab-technical
    .peer-com-table
    tbody
    td.ma25d.nochange {
    color: var(--text-unchg-color);
  }
  .stock-peer-com-container.tab-technical .peer-com-table thead th.ma5d,
  .stock-peer-com-container.tab-technical .peer-com-table tbody td.ma5d,
  .stock-peer-com-container.tab-technical .peer-com-table thead th.ma25d,
  .stock-peer-com-container.tab-technical .peer-com-table tbody td.ma25d {
    min-width: 120px;
    max-width: 120px;
    width: 120px;
  }
  .stock-peer-com-container.tab-technical .peer-com-table thead th.beta,
  .stock-peer-com-container.tab-technical .peer-com-table tbody td.beta {
    min-width: 80px;
    width: 80px;
  }
  .stock-peer-com-container.tab-technical .peer-com-table thead th.avgvol30,
  .stock-peer-com-container.tab-technical .peer-com-table tbody td.avgvol30 {
    min-width: 120px;
    width: 120px;
  }
  .stock-peer-com-container.tab-performance .peer-com-table thead th.pctchng,
  .stock-peer-com-container.tab-performance .peer-com-table tbody td.pctchng {
    padding-right: 42px;
  }
  .stock-peer-com-container.tab-performance .peer-com-table thead th.last,
  .stock-peer-com-container.tab-performance .peer-com-table tbody td.last {
    padding-right: 42px;
  }
  .stock-peer-com-container.tab-summary .peer-com-table thead th.divyield,
  .stock-peer-com-container.tab-summary .peer-com-table tbody td.divyield {
    max-width: 128px;
    min-width: 128px;
    width: 128px;
  }
  .stock-peer-com-container .peer-com-table tbody td.perf1M,
  .stock-peer-com-container .peer-com-table tbody td.perf3M,
  .stock-peer-com-container .peer-com-table tbody td.perf6M,
  .stock-peer-com-container .peer-com-table tbody td.perf1Y {
    border-left: 1px solid var(--surface-primary);
  }

  .stock-peer-com-container .peer-com-table thead th.perf1M,
  .stock-peer-com-container .peer-com-table thead th.perf3M,
  .stock-peer-com-container .peer-com-table thead th.perf6M,
  .stock-peer-com-container .peer-com-table thead th.perf1Y {
    text-align: center;
  }
  .stock-peer-com-container .peer-com-table thead th.brokerrating,
  .stock-peer-com-container .peer-com-table tbody td.brokerrating {
    padding-right: 16px;
  }
  .stock-peer-com-container .peer-com-table thead th.numofbrokers {
    text-align: center;
  }
  .stock-peer-com-container .peer-com-table thead th.targetprice,
  .stock-peer-com-container .peer-com-table tbody td.targetprice {
    min-width: 150px;
    max-width: 150px;
    width: 150px;
  }
  .stock-peer-com-container.tab-performance .peer-com-table tbody td.perf1Y {
    padding-right: 8px;
  }
}

.sort-icon-asc path,
.sort-icon-desc path {
  fill: var(--color-brand);
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/StockPeerComparisonWidget/StockPeerComparisonWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;;EAEpC,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB;kCACgC;EAChC,0BAA0B;;EAE1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;EAC3C,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;;;;;;EAME,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,sBAAsB;;EAEtB;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;;EAEtB;IACE,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,0CAA0C;IAC1C,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,sCAAsC;IACtC,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,6CAA6C;IAC7C,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,6CAA6C;IAC7C,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,6CAA6C;IAC7C,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,6CAA6C;IAC7C,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0CAA0C;IAC1C,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0CAA0C;IAC1C,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0CAA0C;IAC1C,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0CAA0C;IAC1C,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0CAA0C;IAC1C,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0CAA0C;IAC1C,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0CAA0C;IAC1C,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,qCAAqC;IACrC,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,qCAAqC;IACrC,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,0CAA0C;IAC1C,0BAA0B;IAC1B,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,uCAAuC;IACvC,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,uCAAuC;IACvC,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,0CAA0C;IAC1C,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,4CAA4C;IAC5C,+CAA+C;EACjD;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;0EAE0E;AAC1E;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;;;;;;;;;;;;;;;;;;EAkBE,eAAe;EACf,kBAAkB;AACpB;AACA;;;;;;;EAOE,eAAe;EACf,WAAW;AACb;AACA;;EAEE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;;;;IAKE,YAAY;EACd;EACA;;IAEE,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,YAAY;IACZ;MACE,UAAU;MACV,cAAc;IAChB;IACA;MACE,iBAAiB;MACjB,kBAAkB;IACpB;EACF;EACA;;IAEE,WAAW;EACb;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;;IAElB;MACE,kBAAkB;IACpB;IACA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,sBAAsB;IACxB;IACA;MACE,eAAe;MACf,gBAAgB;MAChB,sBAAsB;IACxB;IACA;MACE,kBAAkB;MAClB,gBAAgB;MAChB,sBAAsB;IACxB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,eAAe;MACf,kBAAkB;IACpB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,mBAAmB;IACrB;EACF;EACA;;;;;;;IAOE,WAAW;EACb;;EAEA;;;;IAIE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;;;;;;;;IAQE,2BAA2B;EAC7B;EACA;;;;;;;;IAQE,6BAA6B;EAC/B;EACA;;;;;;;;IAQE,8BAA8B;EAChC;EACA;;;;IAIE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;EACA;;IAEE,eAAe;IACf,WAAW;EACb;EACA;;IAEE,gBAAgB;IAChB,YAAY;EACd;EACA;;IAEE,mBAAmB;EACrB;EACA;;IAEE,mBAAmB;EACrB;EACA;;IAEE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;EACA;;;;IAIE,6CAA6C;EAC/C;;EAEA;;;;IAIE,kBAAkB;EACpB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;;EAEE,wBAAwB;AAC1B","sourcesContent":[".stock-peer-com-container {\n  container-type: inline-size;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  height: 100%;\n  min-width: 328px;\n  display: flex;\n  flex-direction: column;\n}\n\n.stock-peer-com-container > div {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: auto;\n}\n\n.stock-peer-com-container .pagination-background {\n  margin-top: auto;\n  cursor: auto;\n}\n\n.stock-peer-com-container .select-container {\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-bottom: 14px;\n  display: flex;\n  justify-content: flex-start;\n}\n\n.stock-peer-com-container select {\n  width: 100%;\n  opacity: 1;\n  padding-top: 8px;\n  padding-right: 16px;\n  padding-bottom: 8px;\n  padding-left: 16px;\n  border-radius: 8px;\n  border-width: 1px;\n  border: 1px solid var(--color-brand);\n\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: url(\"data:image/svg+xml;utf8,<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M8.00045 8.78126L11.3003 5.48145L12.2431 6.42425L8.00045 10.6669L3.75781 6.42425L4.70063 5.48145L8.00045 8.78126Z' fill='%231E1F2F'/></svg>\")\n    no-repeat right 0.75rem center;\n  background-size: 16px 16px;\n\n  color: var(--text-primary);\n  font-size: 16px;\n}\n\n.stock-peer-com-container select:focus {\n  outline: none;\n}\n\n.stock-peer-com-container .peer-com-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0px;\n  table-layout: fixed;\n  margin-top: 10px;\n}\n\n.stock-peer-com-container .peer-com-table thead th svg {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 2px;\n  transition: transform 0.2s ease;\n}\n\n.stock-peer-com-container .peer-com-table thead th {\n  border-bottom: 1px solid var(--border-line);\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 16px;\n  letter-spacing: 0;\n  color: var(--text-subheader);\n  vertical-align: sub;\n  white-space: nowrap;\n  height: 32px;\n  padding-bottom: 0px;\n  box-sizing: border-box;\n}\n\n.stock-peer-com-container .peer-com-table thead th div {\n  cursor: pointer;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n  gap: 2px;\n}\n\n.stock-peer-com-container .peer-com-table thead th.no div,\n.stock-peer-com-container .peer-com-table thead th.ticker div,\n.stock-peer-com-container .peer-com-table thead th.tickerName div,\n.stock-peer-com-container .peer-com-table thead th.name div,\n.stock-peer-com-container .peer-com-table thead th.ctry div,\n.stock-peer-com-container .peer-com-table thead th.numofbrokers div {\n  justify-content: flex-start;\n}\n\n.stock-peer-com-container .peer-com-table thead th div svg {\n  flex-shrink: 0;\n}\n\n.stock-peer-com-container .peer-com-table thead th .peer-com-header-label {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.stock-peer-com-container .peer-com-table thead th:first-child {\n  width: 22px;\n  border-bottom: 0px;\n}\n\n.stock-peer-com-container .peer-com-table thead .no {\n  text-align: start;\n  width: 20px;\n}\n\n.stock-peer-com-container .peer-com-table thead .ticker {\n  text-align: start;\n  width: 100px;\n}\n\n.stock-peer-com-container .peer-com-table thead .name {\n  text-align: start;\n  width: 20%;\n}\n\n.stock-peer-com-container .peer-com-table thead .tickerName {\n  text-align: start;\n}\n\n.stock-peer-com-container .peer-com-table thead .ctry {\n  width: 5%;\n}\n\n.stock-peer-com-container .peer-com-table thead .last {\n  text-align: end;\n  width: 14%;\n}\n\n.stock-peer-com-container .peer-com-table thead .pctchng {\n  text-align: end;\n  width: 12%;\n}\n\n.stock-peer-com-container .peer-com-table thead .mktcap {\n  text-align: end;\n  width: 140px;\n}\n\n.stock-peer-com-container\n  .peer-com-table\n  thead\n  .mktcap\n  .peer-com-header-currency {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  letter-spacing: 0;\n  color: var(--text-subheader);\n}\n\n.stock-peer-com-container .peer-com-table thead .peratio {\n  text-align: end;\n  width: 90px;\n}\n\n.stock-peer-com-container .peer-com-table thead .coscore {\n  text-align: end;\n  width: 144px;\n}\n\n.stock-peer-com-container .peer-com-table thead .divyield {\n  text-align: end;\n  width: 90px;\n}\n\n.stock-peer-com-container .peer-com-table thead .consensus {\n  text-align: end;\n  width: 120px;\n}\n\n.stock-peer-com-container .peer-com-table thead .perf1M {\n  text-align: end;\n  width: 120px;\n}\n\n.stock-peer-com-container .peer-com-table thead .perf3M {\n  text-align: end;\n  width: 120px;\n}\n\n.stock-peer-com-container .peer-com-table thead .perf6M {\n  text-align: end;\n  width: 120px;\n}\n\n.stock-peer-com-container .peer-com-table thead .perf1Y {\n  text-align: end;\n  width: 120px;\n}\n\n.stock-peer-com-container .peer-com-table thead .numofbrokers {\n  text-align: center;\n}\n\n.stock-peer-com-container .peer-com-table thead .beta {\n  text-align: end;\n  width: 90px;\n}\n\n.stock-peer-com-container .peer-com-table thead .avgvol30 {\n  text-align: end;\n  width: 115px;\n}\n\n.stock-peer-com-container .peer-com-table thead .rsi {\n  text-align: end;\n  width: 90px;\n}\n\n.stock-peer-com-container .peer-com-table thead .ma5d {\n  text-align: end;\n  width: 90px;\n}\n\n.stock-peer-com-container .peer-com-table thead .ma25d {\n  text-align: end;\n  width: 90px;\n}\n\n.stock-peer-com-container .peer-com-table thead .per {\n  text-align: end;\n  width: 90px;\n}\n\n.stock-peer-com-container .peer-com-table thead .pbr {\n  text-align: end;\n  width: 90px;\n}\n\n.stock-peer-com-container .peer-com-table thead .roe {\n  text-align: end;\n  width: 90px;\n}\n\n.stock-peer-com-container .peer-com-table thead .overall {\n  text-align: end;\n  width: 80px;\n}\n\n.stock-peer-com-container .peer-com-table thead .fundamental {\n  text-align: end;\n  width: 125px;\n}\n\n.stock-peer-com-container .peer-com-table thead .earnings {\n  text-align: end;\n  width: 100px;\n}\n\n.stock-peer-com-container .peer-com-table thead .valuation {\n  text-align: end;\n  width: 90px;\n}\n\n.stock-peer-com-container .peer-com-table thead .performance {\n  text-align: end;\n  width: 115px;\n}\n\n.stock-peer-com-container .peer-com-table thead .risk {\n  text-align: end;\n  width: 80px;\n}\n\n.stock-peer-com-container .peer-com-table thead .targetprice {\n  text-align: end;\n  width: 120px;\n}\n\n.stock-peer-com-container .peer-com-table thead .brokerrating {\n  text-align: end;\n  width: 145px;\n}\n\n.stock-peer-com-container .peer-com-table thead th:last-child {\n  width: 22px;\n  border-bottom: 0px;\n}\n\n.stock-peer-com-container .peer-com-table thead .lastcolumn {\n  width: 0;\n}\n\n.stock-peer-com-container .peer-com-table tbody tr {\n  vertical-align: middle;\n\n  &:nth-child(2n) {\n    background-color: var(--row-dark);\n  }\n}\n\n.stock-peer-com-container .peer-com-table tbody .numofbrokers {\n  text-align: center;\n}\n\n.stock-peer-com-container .peer-com-table tbody td {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  vertical-align: middle;\n  white-space: nowrap;\n  box-sizing: border-box;\n\n  &:first-child {\n    padding-left: 32px;\n  }\n\n  &.nochange {\n    color: var(--text-unchg-color);\n  }\n\n  &.positive {\n    color: var(--text-up-color);\n  }\n\n  &.negative {\n    color: var(--text-down-color);\n  }\n\n  &.no {\n    text-align: justify;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: 0;\n    color: var(--text-subheader);\n    padding-right: 8px;\n  }\n\n  &.ctry {\n    text-align: left;\n    padding-right: 8px;\n    text-align: center;\n  }\n\n  &.ctry svg {\n    width: 20px;\n    height: 20px;\n  }\n\n  &.ticker {\n    text-align: left;\n    font-weight: 700;\n    font-size: 16px;\n    color: var(--text-ticker);\n    padding-right: 8px;\n    width: 6%;\n    cursor: pointer;\n  }\n\n  &.ticker.link-enabled {\n    cursor: pointer;\n  }\n\n  &.name {\n    text-align: left;\n    font-weight: 400;\n    font-size: 16px;\n    letter-spacing: 0;\n    color: #1e1f2f;\n    width: 20%;\n  }\n\n  &.name.link-enabled {\n    cursor: pointer;\n  }\n\n  &.name.link-enabled:hover {\n    color: var(--accent-link);\n  }\n\n  &.tickerName {\n    text-align: left;\n    width: 30%;\n    min-width: 30%;\n    padding-left: 8px;\n  }\n\n  &.tickerName .ticker {\n    font-weight: 400;\n    font-size: 16px;\n    color: var(--text-primary);\n    cursor: pointer;\n  }\n\n  &.tickerName .name {\n    text-align: left;\n    font-weight: 400;\n    font-size: 12px;\n    letter-spacing: 0;\n    color: var(--text-primary);\n    padding-right: 8px;\n  }\n\n  &.tickerName .tickerNameSmallScreen {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n\n  &.tickerName .tickerNameSmallScreen .name {\n    width: 100%;\n  }\n\n  &.last {\n    text-align: right;\n    font-weight: 400;\n    font-size: 16px;\n    letter-spacing: 0;\n    padding-right: 8px;\n    color: var(--text-primary);\n  }\n\n  &.pctchng {\n    text-align: right;\n    font-weight: 400;\n    font-size: 16px;\n    letter-spacing: 0;\n    padding-right: 8px;\n  }\n\n  &.mktcap {\n    text-align: right;\n    font-weight: 400;\n    font-size: 16px;\n    letter-spacing: 0;\n    color: var(--text-primary);\n    padding-right: 8px;\n  }\n\n  &.mktcap .peer-com-header-currency {\n    font-size: 11px;\n    line-height: 100%;\n  }\n\n  &.peratio {\n    text-align: right;\n    font-weight: 400;\n    font-size: 16px;\n    letter-spacing: 0;\n    color: var(--text-primary);\n    padding-right: 8px;\n  }\n\n  &.divyield {\n    text-align: right;\n    font-weight: 400;\n    font-size: 16px;\n    color: var(--text-primary);\n    padding-right: 8px;\n  }\n\n  &.coscore {\n    vertical-align: middle;\n    padding-right: 8px;\n  }\n\n  &.coscore span {\n    width: 44px;\n    display: inline-block;\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: 0;\n    border-radius: 1px;\n    white-space: nowrap;\n    text-align: center;\n    padding-top: 3px;\n    padding-bottom: 3px;\n  }\n\n  &.coscore .score {\n    text-align: center;\n    background-color: var(--surface-secondary);\n    color: var(--text-primary);\n  }\n\n  &.coscore .score-10 {\n    text-align: center;\n    background-color: var(--surface-brand);\n    color: var(--text-invert);\n  }\n\n  &.div-consensus {\n    vertical-align: middle;\n  }\n\n  &.div-consensus span {\n    display: inline-block;\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: 0;\n    border-radius: 1px;\n    white-space: nowrap;\n    text-align: center;\n    padding-top: 3px;\n    padding-bottom: 3px;\n  }\n\n  &.div-consensus .strongbuy {\n    color: var(--text-invert);\n    background-color: var(--heatmap-up-5);\n  }\n\n  &.perf1M {\n    text-align: right;\n    font-weight: 400;\n    font-size: 16px;\n    border-left: 0px solid var(--surface-primary);\n    width: 120px;\n    padding-right: 8px;\n    max-height: 56px;\n    padding-top: 0px;\n    padding-bottom: 0px;\n  }\n\n  &.perf3M {\n    text-align: right;\n    font-weight: 400;\n    font-size: 16px;\n    border-left: 0px solid var(--surface-primary);\n    width: 120px;\n    padding-right: 8px;\n    max-height: 56px;\n    padding-top: 0px;\n    padding-bottom: 0px;\n  }\n\n  &.perf6M {\n    text-align: right;\n    font-weight: 400;\n    font-size: 16px;\n    border-left: 0px solid var(--surface-primary);\n    width: 120px;\n    padding-right: 8px;\n    max-height: 56px;\n    padding-top: 0px;\n    padding-bottom: 0px;\n  }\n\n  &.perf1Y {\n    text-align: right;\n    font-weight: 400;\n    font-size: 16px;\n    border-left: 0px solid var(--surface-primary);\n    width: 120px;\n    padding-right: 8px;\n    max-height: 56px;\n    padding-top: 0px;\n    padding-bottom: 0px;\n  }\n\n  &.numofbrokers {\n    text-align: center;\n  }\n\n  &.beta {\n    font-weight: 400;\n    font-style: Regular;\n    font-size: 16px;\n    letter-spacing: 0px;\n    text-align: right;\n    padding-right: 8px;\n    color: var(--text-primary);\n  }\n\n  &.avgvol30 {\n    font-weight: 400;\n    font-size: 16px;\n    letter-spacing: 0px;\n    text-align: right;\n    padding-right: 8px;\n    color: var(--text-primary);\n  }\n\n  &.rsi {\n    font-weight: 400;\n    font-style: Regular;\n    font-size: 16px;\n    letter-spacing: 0px;\n    text-align: right;\n    padding-right: 8px;\n    color: var(--text-primary);\n  }\n\n  &.ma5d {\n    font-weight: 400;\n    font-style: Regular;\n    font-size: 16px;\n    letter-spacing: 0px;\n    text-align: right;\n    padding-right: 8px;\n  }\n\n  &.ma25d {\n    font-weight: 400;\n    font-style: Regular;\n    font-size: 16px;\n    letter-spacing: 0px;\n    text-align: right;\n    padding-right: 8px;\n  }\n\n  &.per {\n    font-weight: 400;\n    font-style: Regular;\n    font-size: 16px;\n    letter-spacing: 0px;\n    text-align: right;\n    padding-right: 8px;\n    color: var(--text-primary);\n  }\n\n  &.pbr {\n    font-weight: 400;\n    font-style: Regular;\n    font-size: 16px;\n    letter-spacing: 0px;\n    text-align: right;\n    padding-right: 8px;\n    color: var(--text-primary);\n  }\n\n  &.roe {\n    font-weight: 400;\n    font-style: Regular;\n    font-size: 16px;\n    letter-spacing: 0px;\n    text-align: right;\n    padding-right: 8px;\n    color: var(--text-primary);\n  }\n\n  &.overall {\n    padding-right: 8px;\n    text-align: center;\n  }\n\n  &.overall span {\n    width: 44px;\n    display: inline-block;\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: 0;\n    border-radius: 1px;\n    white-space: nowrap;\n    padding-top: 3px;\n    padding-bottom: 3px;\n  }\n\n  &.overall .score {\n    background-color: var(--surface-secondary);\n    color: var(--text-primary);\n    text-align: center;\n  }\n\n  &.overall .score-10 {\n    background-color: var(--surface-brand);\n    color: var(--text-invert);\n    text-align: center;\n  }\n\n  &.fundamental {\n    padding-right: 8px;\n    text-align: center;\n  }\n\n  &.fundamental span {\n    width: 44px;\n    display: inline-block;\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: 0;\n    border-radius: 1px;\n    white-space: nowrap;\n    padding-top: 3px;\n    padding-bottom: 3px;\n  }\n\n  &.fundamental .score {\n    background-color: var(--surface-secondary);\n    color: var(--text-primary);\n    text-align: center;\n  }\n\n  &.fundamental .score-10 {\n    background-color: var(--surface-brand);\n    color: var(--text-invert);\n    text-align: center;\n  }\n\n  &.earnings {\n    padding-right: 8px;\n    text-align: center;\n  }\n\n  &.earnings span {\n    width: 44px;\n    display: inline-block;\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: 0;\n    border-radius: 1px;\n    white-space: nowrap;\n    padding-top: 3px;\n    padding-bottom: 3px;\n  }\n\n  &.earnings .score {\n    background-color: var(--surface-secondary);\n    color: var(--text-primary);\n    text-align: center;\n  }\n\n  &.earnings .score-10 {\n    background-color: var(--surface-brand);\n    color: var(--text-invert);\n    text-align: center;\n  }\n\n  &.valuation {\n    padding-right: 8px;\n    text-align: center;\n  }\n\n  &.valuation span {\n    width: 44px;\n    display: inline-block;\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: 0;\n    border-radius: 1px;\n    white-space: nowrap;\n    padding-top: 3px;\n    padding-bottom: 3px;\n  }\n\n  &.valuation .score {\n    background-color: var(--surface-secondary);\n    color: var(--text-primary);\n    text-align: center;\n  }\n\n  &.valuation .score-10 {\n    background-color: var(--surface-brand);\n    color: var(--text-invert);\n    text-align: center;\n  }\n\n  &.performance {\n    padding-right: 8px;\n    text-align: center;\n  }\n\n  &.performance span {\n    width: 44px;\n    display: inline-block;\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: 0;\n    border-radius: 1px;\n    white-space: nowrap;\n    padding-top: 3px;\n    padding-bottom: 3px;\n  }\n\n  &.performance .score {\n    background-color: var(--surface-secondary);\n    color: var(--text-primary);\n    text-align: center;\n  }\n\n  &.performance .score-10 {\n    background-color: var(--surface-brand);\n    color: var(--text-invert);\n    text-align: center;\n  }\n\n  &.risk {\n    padding-right: 8px;\n    text-align: center;\n  }\n\n  &.risk span {\n    width: 44px;\n    display: inline-block;\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: 0;\n    border-radius: 1px;\n    white-space: nowrap;\n    padding-top: 3px;\n    padding-bottom: 3px;\n  }\n\n  &.risk .score {\n    background-color: var(--surface-secondary);\n    color: var(--text-primary);\n    text-align: center;\n  }\n\n  &.risk .score-10 {\n    background-color: var(--surface-brand);\n    color: var(--text-invert);\n    text-align: center;\n  }\n\n  &.targetprice {\n    font-weight: 400;\n    font-size: 16px;\n    letter-spacing: 0px;\n    text-align: right;\n    padding-right: 8px;\n    color: var(--text-primary);\n  }\n\n  &.brokerrating {\n    vertical-align: middle;\n    padding-right: 8px;\n    justify-content: flex-end;\n  }\n\n  &.brokerrating span {\n    display: inline-block;\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: 0;\n    border-radius: 1px;\n    white-space: nowrap;\n    text-align: center;\n    padding-top: 3px;\n    padding-bottom: 3px;\n  }\n\n  &.brokerrating .score {\n    background-color: var(--surface-secondary);\n    color: var(--text-primary);\n    text-align: center;\n  }\n\n  &.brokerrating .score-10 {\n    background-color: var(--surface-brand);\n    color: var(--text-invert);\n    text-align: center;\n  }\n\n  &.firstcolumn {\n    width: 0;\n  }\n\n  &.lastcolumn {\n    width: 0;\n  }\n\n  &:nth-last-child(2) {\n    padding-right: 0px;\n  }\n}\n\n.stock-peer-com-container {\n  .sortbtn {\n    vertical-align: middle;\n  }\n\n  .rec-strong-buy {\n    background-color: var(--heatmap-up-5);\n    color: var(--text-invert);\n    padding: 3px 8px 3px 8px;\n  }\n\n  .rec-buy {\n    background-color: var(--heatmap-up-4);\n    color: var(--text-invert);\n    text-align: center;\n    padding: 3px 8px 3px 8px;\n  }\n\n  .rec-hold {\n    background-color: var(--surface-secondary);\n    color: var(--text-primary);\n    text-align: center;\n    padding: 3px 8px 3px 8px;\n  }\n\n  .rec-reduce {\n    background-color: var(--heatmap-down-4);\n    color: var(--text-invert);\n    text-align: center;\n    padding: 3px 8px 3px 8px;\n  }\n\n  .rec-sell {\n    background-color: var(--heatmap-down-6);\n    color: var(--text-invert);\n    text-align: center;\n    padding: 3px 8px 3px 8px;\n  }\n\n  .peer-com-whitespace {\n    height: 24px;\n  }\n\n  .peer-com-pagination {\n    padding: 32px;\n    background-color: var(--surface-secondary);\n    margin-top: auto;\n  }\n\n  .alignRight {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .alignCenter {\n    display: flex;\n    justify-content: center;\n  }\n\n  .per-whiteBorder {\n    border-top: 1px solid var(--surface-primary);\n    border-bottom: 1px solid var(--surface-primary);\n  }\n\n  .peer-com-tbl-cel-flex-container {\n    display: grid;\n    align-items: center;\n    max-width: 90%;\n  }\n\n  .peer-com-tbl-cel-text {\n    flex: 1 1 0;\n    min-width: 0;\n    /* critical for ellipsis in flex items */\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.peer-com-table-spacer {\n  height: 16px;\n}\n\n.stock-peer-com-container .select-container {\n  padding-left: 8px;\n  padding-right: 8px;\n  padding-bottom: 8px;\n}\n.peer-com-table-spacer {\n  max-height: 8px;\n}\n.stock-peer-com-container select {\n  font-size: 13px;\n  padding: 6px 10px;\n}\n.stock-peer-com-container .peer-com-table thead th {\n  font-size: 16px;\n  height: 26px;\n  width: 20px;\n}\n.stock-peer-com-container .peer-com-table thead th:first-child,\n.stock-peer-com-container .peer-com-table thead th:last-child {\n  width: 8px;\n}\n.stock-peer-com-container .peer-com-table thead .no {\n  width: 37px;\n}\n.stock-peer-com-container .peer-com-table thead .tickerName--ticker {\n  width: 72px;\n}\n/* Auto width: this column absorbs the table's leftover space (table-layout\n     is fixed), which keeps the fixed-width columns — notably the 139px last\n     column — at exactly their declared width instead of being inflated. */\n.stock-peer-com-container .peer-com-table thead .tickerName--name {\n  width: auto;\n}\n.stock-peer-com-container .peer-com-table tbody tr {\n  height: 56px;\n}\n.stock-peer-com-container .peer-com-table tbody td {\n  font-size: 12px;\n  padding-top: 12px;\n  padding-bottom: 8px;\n  padding-right: 4px;\n}\n.stock-peer-com-container .peer-com-table tbody td:first-child {\n  padding-left: 8px;\n}\n.stock-peer-com-container .peer-com-table tbody td.no {\n  font-size: 14px;\n  padding-right: 4px;\n  padding-top: 12px;\n  padding-left: 8px;\n  vertical-align: top;\n}\n.stock-peer-com-container .peer-com-table tbody td.name {\n  font-size: 16px;\n}\n.stock-peer-com-container .peer-com-table tbody td.ticker {\n  font-size: 12px;\n  padding-right: 4px;\n}\n.stock-peer-com-container .peer-com-table tbody td.tickerName {\n  padding-left: 36px;\n}\n.stock-peer-com-container .peer-com-table tbody td.tickerName .ticker {\n  font-size: 16px;\n  color: var(--text-ticker);\n  font-weight: 700;\n}\n.stock-peer-com-container .peer-com-table tbody td.tickerName .name {\n  font-size: 14px;\n  padding-right: 4px;\n}\n.stock-peer-com-container .peer-com-table tbody td.ctry {\n  padding-left: 24px;\n  padding-top: 0px;\n  padding-right: 16px;\n  vertical-align: middle;\n}\n.stock-peer-com-container .peer-com-table tbody td.last,\n.stock-peer-com-container .peer-com-table tbody td.pctchng,\n.stock-peer-com-container .peer-com-table tbody td.mktcap,\n.stock-peer-com-container .peer-com-table tbody td.peratio,\n.stock-peer-com-container .peer-com-table tbody td.divyield,\n.stock-peer-com-container .peer-com-table tbody td.targetprice,\n.stock-peer-com-container .peer-com-table tbody td.beta,\n.stock-peer-com-container .peer-com-table tbody td.avgvol30,\n.stock-peer-com-container .peer-com-table tbody td.rsi,\n.stock-peer-com-container .peer-com-table tbody td.ma5d,\n.stock-peer-com-container .peer-com-table tbody td.ma25d,\n.stock-peer-com-container .peer-com-table tbody td.per,\n.stock-peer-com-container .peer-com-table tbody td.pbr,\n.stock-peer-com-container .peer-com-table tbody td.roe,\n.stock-peer-com-container .peer-com-table tbody td.perf1M,\n.stock-peer-com-container .peer-com-table tbody td.perf3M,\n.stock-peer-com-container .peer-com-table tbody td.perf6M,\n.stock-peer-com-container .peer-com-table tbody td.perf1Y {\n  font-size: 16px;\n  padding-right: 4px;\n}\n.stock-peer-com-container .peer-com-table tbody td.coscore span,\n.stock-peer-com-container .peer-com-table tbody td.overall span,\n.stock-peer-com-container .peer-com-table tbody td.fundamental span,\n.stock-peer-com-container .peer-com-table tbody td.earnings span,\n.stock-peer-com-container .peer-com-table tbody td.valuation span,\n.stock-peer-com-container .peer-com-table tbody td.performance span,\n.stock-peer-com-container .peer-com-table tbody td.risk span {\n  font-size: 16px;\n  width: 36px;\n}\n.stock-peer-com-container .peer-com-table tbody td.div-consensus span,\n.stock-peer-com-container .peer-com-table tbody td.brokerrating span {\n  font-size: 16px;\n}\n.stock-peer-com-container .peer-com-table tbody td:nth-last-child(2) {\n  padding-right: 0px;\n}\n\n@container (max-width: 767.98px) {\n  .stock-peer-com-container .peer-com-table thead th:nth-last-child(2),\n  .stock-peer-com-container .peer-com-table tbody td:nth-last-child(2) {\n    width: 139px;\n    overflow: hidden;\n  }\n\n  .stock-peer-com-container\n    .peer-com-table\n    thead\n    th:nth-last-child(2)\n    .peer-com-header-label {\n    min-width: 0;\n  }\n  .stock-peer-com-container .peer-com-table tbody td:nth-last-child(2),\n  .stock-peer-com-container .peer-com-table tbody td:nth-last-child(2) > div {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n}\n\n@container (min-width: 768px) {\n  .stock-peer-com-container .select-container {\n    padding-left: 24px;\n    padding-right: 24px;\n    padding-bottom: 14px;\n  }\n  .stock-peer-com-container select {\n    font-size: 16px;\n    padding: 8px 16px;\n  }\n  .peer-com-table-spacer {\n    max-height: unset;\n    height: 8px;\n  }\n  .stock-peer-com-container .peer-com-table thead th {\n    height: 32px;\n    &.name {\n      width: 35%;\n      min-width: 35%;\n    }\n    &:nth-last-child(2) {\n      text-align: right;\n      padding-right: 0px;\n    }\n  }\n  .stock-peer-com-container .peer-com-table thead th:first-child,\n  .stock-peer-com-container .peer-com-table thead th:last-child {\n    width: 22px;\n  }\n  .stock-peer-com-container .peer-com-table thead .no {\n    width: 20px;\n    padding-left: 0;\n  }\n  .stock-peer-com-container .peer-com-table thead .tickerName {\n    padding-left: 8px;\n  }\n  .stock-peer-com-container .peer-com-table thead .numofbrokers {\n    width: 180px;\n  }\n\n  .stock-peer-com-container .peer-com-table tbody tr {\n    height: 40px;\n  }\n  .stock-peer-com-container .peer-com-table tbody td {\n    font-size: 16px;\n    padding-top: 4px;\n    padding-bottom: 4px;\n    padding-right: 8px;\n\n    &:first-child {\n      padding-left: 24px;\n    }\n    &.ticker {\n      font-size: 16px;\n    }\n\n    &.no {\n      padding-left: 0;\n      vertical-align: middle;\n    }\n    &.no {\n      padding-left: 0;\n      padding-top: 4px;\n      vertical-align: middle;\n    }\n    &.ctry {\n      padding-right: 8px;\n      padding-top: 4px;\n      vertical-align: middle;\n    }\n    &.tickerName {\n      padding-left: 8px;\n    }\n    &.tickerName .name {\n      font-size: 12px;\n      padding-right: 8px;\n    }\n    &:nth-last-child(2) {\n      padding-right: 0px;\n    }\n    &:last-child {\n      padding-right: 22px;\n    }\n  }\n  .stock-peer-com-container .peer-com-table tbody td.coscore span,\n  .stock-peer-com-container .peer-com-table tbody td.overall span,\n  .stock-peer-com-container .peer-com-table tbody td.fundamental span,\n  .stock-peer-com-container .peer-com-table tbody td.earnings span,\n  .stock-peer-com-container .peer-com-table tbody td.valuation span,\n  .stock-peer-com-container .peer-com-table tbody td.performance span,\n  .stock-peer-com-container .peer-com-table tbody td.risk span {\n    width: 44px;\n  }\n\n  .stock-peer-com-container .peer-com-table thead .ticker,\n  .stock-peer-com-container .peer-com-table tbody td.ticker,\n  .stock-peer-com-container .peer-com-table thead .ctry,\n  .stock-peer-com-container .peer-com-table tbody td.ctry {\n    padding-left: 16px;\n  }\n\n  .stock-peer-com-container .custom-select-wrapper {\n    max-width: 345px;\n    width: 100%;\n  }\n}\n@container (min-width: 1200px) {\n  .stock-peer-com-container .peer-com-table tbody td.pctchng {\n    background-color: transparent;\n  }\n  .stock-peer-com-container .peer-com-table tbody td.pctchng.positive {\n    color: var(--text-up-color);\n  }\n  .stock-peer-com-container .peer-com-table tbody td.pctchng.negative,\n  .stock-peer-com-container .peer-com-table tbody td.pctchng.negative-small {\n    color: var(--text-down-color);\n  }\n  .stock-peer-com-container .peer-com-table tbody td.pctchng.nochange {\n    color: var(--text-unchg-color);\n  }\n  .stock-peer-com-container.tab-technical\n    .peer-com-table\n    tbody\n    td.ma5d.positive,\n  .stock-peer-com-container.tab-technical\n    .peer-com-table\n    tbody\n    td.ma25d.positive {\n    color: var(--text-up-color);\n  }\n  .stock-peer-com-container.tab-technical\n    .peer-com-table\n    tbody\n    td.ma5d.negative,\n  .stock-peer-com-container.tab-technical\n    .peer-com-table\n    tbody\n    td.ma25d.negative {\n    color: var(--text-down-color);\n  }\n  .stock-peer-com-container.tab-technical\n    .peer-com-table\n    tbody\n    td.ma5d.nochange,\n  .stock-peer-com-container.tab-technical\n    .peer-com-table\n    tbody\n    td.ma25d.nochange {\n    color: var(--text-unchg-color);\n  }\n  .stock-peer-com-container.tab-technical .peer-com-table thead th.ma5d,\n  .stock-peer-com-container.tab-technical .peer-com-table tbody td.ma5d,\n  .stock-peer-com-container.tab-technical .peer-com-table thead th.ma25d,\n  .stock-peer-com-container.tab-technical .peer-com-table tbody td.ma25d {\n    min-width: 120px;\n    max-width: 120px;\n    width: 120px;\n  }\n  .stock-peer-com-container.tab-technical .peer-com-table thead th.beta,\n  .stock-peer-com-container.tab-technical .peer-com-table tbody td.beta {\n    min-width: 80px;\n    width: 80px;\n  }\n  .stock-peer-com-container.tab-technical .peer-com-table thead th.avgvol30,\n  .stock-peer-com-container.tab-technical .peer-com-table tbody td.avgvol30 {\n    min-width: 120px;\n    width: 120px;\n  }\n  .stock-peer-com-container.tab-performance .peer-com-table thead th.pctchng,\n  .stock-peer-com-container.tab-performance .peer-com-table tbody td.pctchng {\n    padding-right: 42px;\n  }\n  .stock-peer-com-container.tab-performance .peer-com-table thead th.last,\n  .stock-peer-com-container.tab-performance .peer-com-table tbody td.last {\n    padding-right: 42px;\n  }\n  .stock-peer-com-container.tab-summary .peer-com-table thead th.divyield,\n  .stock-peer-com-container.tab-summary .peer-com-table tbody td.divyield {\n    max-width: 128px;\n    min-width: 128px;\n    width: 128px;\n  }\n  .stock-peer-com-container .peer-com-table tbody td.perf1M,\n  .stock-peer-com-container .peer-com-table tbody td.perf3M,\n  .stock-peer-com-container .peer-com-table tbody td.perf6M,\n  .stock-peer-com-container .peer-com-table tbody td.perf1Y {\n    border-left: 1px solid var(--surface-primary);\n  }\n\n  .stock-peer-com-container .peer-com-table thead th.perf1M,\n  .stock-peer-com-container .peer-com-table thead th.perf3M,\n  .stock-peer-com-container .peer-com-table thead th.perf6M,\n  .stock-peer-com-container .peer-com-table thead th.perf1Y {\n    text-align: center;\n  }\n  .stock-peer-com-container .peer-com-table thead th.brokerrating,\n  .stock-peer-com-container .peer-com-table tbody td.brokerrating {\n    padding-right: 16px;\n  }\n  .stock-peer-com-container .peer-com-table thead th.numofbrokers {\n    text-align: center;\n  }\n  .stock-peer-com-container .peer-com-table thead th.targetprice,\n  .stock-peer-com-container .peer-com-table tbody td.targetprice {\n    min-width: 150px;\n    max-width: 150px;\n    width: 150px;\n  }\n  .stock-peer-com-container.tab-performance .peer-com-table tbody td.perf1Y {\n    padding-right: 8px;\n  }\n}\n\n.sort-icon-asc path,\n.sort-icon-desc path {\n  fill: var(--color-brand);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
